import React, { useState, useEffect, useCallback, useRef } from 'react';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { Img } from 'react-image';
import * as Yup from 'yup';
import {
  FiEdit2,
  FiHelpCircle,
  FiMessageCircle,
  FiPlay,
  FiSave,
  FiSearch,
} from 'react-icons/fi';
import { FormHandles } from '@unform/core';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { format } from 'date-fns';
import { Form } from '@unform/web';
// servicos
import api from 'services/api';
import getValidationErrors from 'services/getValidationErros';
import notfound from 'assets/semimagem.png';
import NoSearch from 'assets/nosearch.svg';
import { show } from 'store/modules/dialog/actions';
import AppError from 'utils/AppError';

import Spinner from 'components/Spinner';
import Card from 'components/Card';
import PlayerBaixa from 'components/PlayerBaixa';
import Pagination from 'components/Pagination';
import Input from 'components/Input';
import NotFound from 'components/NotFound';
import Loader from 'components/ContentLoader/ORALoader';
import { Comercial, MelhoriaDoBreak_Categoria } from 'pages/@types';

import { Table, ThumbnailContainer } from 'styles/global';
import {
  AvaliacaoHelp,
  Avaliacoes,
  Botoes,
  Comunicacao,
  Container,
  Dados,
  Header,
  SearchBar,
  THead,
  Thumbnail,
} from './styles';
import ReactStars from 'react-stars';
import Flag from 'components/Flag';
import Button from 'components/Button';
import Tooltip from 'components/Tooltip';
import TextArea from 'components/TextArea';
import { useModal } from 'hooks/modal';
import Select from 'components/Select';
import SelectWithoutForm from 'components/Select/withoutForm';
import Switch from 'components/Switch';
// configuração do validator
const schema = Yup.object().shape({
  notificacao: Yup.string()
    .required('Campo Obrigatório')
    .nullable(),
  motivo: Yup.string()
    .required('Campo Obrigatório')
    .nullable(),
  emailnotificacao: Yup.string().required('Campo Obrigatório'),
  feedback: Yup.boolean().required('Campo Obrigatório'),
  comentariosfeedback: Yup.string().when('feedback', {
    is: true,
    then: Yup.string().required('Campo Obrigatório'),
  }),
});
interface ISelectOption {
  value: string;
  label: string;
}
export default function MelhoriaDoBreak() {
  /**
   * USE STATE
   */
  const [player, setPlayer] = useState({
    open: false,
    midia_url: '',
    pipe: false,
  });
  const [loading, setLoading] = useState(false);
  const [comerciais, setComerciais] = useState<Comercial[]>([]);
  const [page, setPage] = useState(1);
  const [displaySearch, setDisplaySearch] = useState(false);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [disableSave, setDisableSave] = useState(true);
  const [filtro, setFiltro] = useState('');
  const [pages, setPages] = useState(1);
  const [categorias, setCategorias] = useState<ISelectOption[]>([]);

  const { showModal, hideModal } = useModal();
  /**
   * REDUX
   */
  const dispatch = useDispatch();
  /**
   * USE REF
   */
  const selectedId = useRef(0);
  const ref = useRef<FormHandles>(null);
  const formRef = useRef<FormHandles>(null);

  const NotificacaoOptions = [
    { value: 'insight', label: 'INSIGHT' },
    { value: 'alerta', label: 'ALERTA' },
  ];
  const MotivoOptions = [
    { value: 'varios', label: 'VÁRIOS' },
    { value: 'locucao', label: 'LOCUÇÃO' },
    { value: 'lettering', label: 'LETTERING' },
    { value: 'trilha', label: 'TRILHA' },
    { value: 'roteiro', label: 'ROTEIRO' },
    { value: 'calltoaction', label: 'CALL TO ACTION' },
    { value: 'fotografia', label: 'FOTOGRAFIA E IMAGEM' },
    { value: 'logo', label: 'LOGO' },
    { value: 'solicitado', label: 'SOLICITADO' },
    { value: 'clareza', label: 'CLAREZA' },
  ];
  /**
   * USE CALLBACK
   */
  const handlePlayer = useCallback(
    (previewurl: string) => {
      if (previewurl) {
        setPlayer({
          open: !player.open,
          midia_url: previewurl,
          pipe: false,
        });
      } else {
        dispatch(
          show({
            type: 'warning',
            text: 'Preview indisponível no momento',
            showConfirmButton: false,
          }),
        );
      }
    },
    [dispatch, player.open],
  );
  // fecha player
  const closeVideo = useCallback(() => {
    setPlayer({
      open: !player.open,
      midia_url: '',
      pipe: false,
    });
  }, [player.open]);

  const handleSubmit = useCallback(async () => {
    try {
      setLoadingSubmit(true);
      const response = await api.put('/melhoriadobreak', {
        avaliacoes: comerciais.map(c => ({
          id: c.id,
          clareza: c.melhoriadobreak?.clareza || 0,
          criatividade: c.melhoriadobreak?.criatividade || 0,
          direcaodearte: c.melhoriadobreak?.direcaodearte || 0,
          foconavenda: c.melhoriadobreak?.foconavenda || 0,
          fotografia: c.melhoriadobreak?.fotografia || 0,
          linguagem: c.melhoriadobreak?.linguagem || 0,
          roteiro: c.melhoriadobreak?.roteiro || 0,
        })),
      });
      if (response && response.data && response.data.message === 'success') {
        setLoadingSubmit(false);
        toast.success('Avaliações salvas com sucesso');
      } else toast.error('Falha de comunicação com o sistema');
      setDisableSave(true);
    } catch (err) {
      console.log(err);
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (ref.current) ref.current.setErrors(errors);
        toast.error(err.message);
      } else if (err instanceof Error) {
        toast.error(err.message);
      } else {
        const appError = err as AppError;
        toast.error(appError.message);
      }
    }
  }, [comerciais]);

  const handleSubmitCategoria = useCallback(async (id, categoria_id) => {
    try {
      setLoadingSubmit(true);

      const response = await api.patch(`/melhoriadobreak/categoria/${id}`, {
        categoria_id,
      });
      if (response && response.data) {
        setLoadingSubmit(false);
        toast.success('Categoria salva com sucesso');
        setComerciais(prevState =>
          prevState.map(p =>
            p.id === selectedId.current
              ? {
                  ...p,
                  melhoriadobreak: {
                    ...p.melhoriadobreak,
                    melhoriadobreak_categoria: response.data,
                  },
                }
              : p,
          ),
        );
      } else toast.error('Falha de comunicação com o sistema');
      setDisableSave(true);
    } catch (err) {
      console.log(err);
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (ref.current) ref.current.setErrors(errors);
        toast.error(err.message);
      } else if (err instanceof Error) {
        toast.error(err.message);
      } else {
        const appError = err as AppError;
        toast.error(appError.message);
      }
    }
  }, []);

  const handleEditCategoria = useCallback(
    c => {
      selectedId.current = c.id;
      if (formRef.current) formRef.current.setErrors({});
      showModal({
        title: 'EDITAR SUBCATEGORIA',
        component: (
          <SelectWithoutForm
            type="default"
            errorField=""
            name="categoria"
            placeholder="Categoria"
            options={categorias}
            isSearchable
            isClearable={false}
            disabled={loadingSubmit}
            fill={false}
            onChange={(categoria: ISelectOption) => {
              selectedId.current = c.id;
              handleSubmitCategoria(c.id, categoria.value);
              hideModal();
            }}
          />
        ),
        width: '30vw',
      });
    },
    [categorias, handleSubmitCategoria, hideModal, loadingSubmit, showModal],
  );

  const handleFiltroSubmit = useCallback(async data => {
    try {
      if (ref.current) {
        setFiltro(data.filtro);
        setPage(1);
      }
    } catch (err) {
      console.log(err);
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        if (ref.current) ref.current.setErrors(errors);
        toast.error(err.message);
      } else if (err instanceof Error) {
        toast.error(err.message);
      } else {
        const appError = err as AppError;
        toast.error(appError.message);
      }
    }
  }, []);

  const handleSubmitComunicacao = useCallback(
    async data => {
      if (formRef.current) {
        setLoadingSubmit(true);
        try {
          formRef.current.setErrors({});

          await schema.validate(data, { abortEarly: false });

          const response = await api.put(
            `/melhoriadobreak/comunicacao/${selectedId.current}`,
            {
              notificacao: data.notificacao,
              feedback: !!data.feedback,
              ...(data.motivo && { motivo: data.motivo }),
              ...(data.emailnotificacao && {
                emailnotificacao: data.emailnotificacao,
              }),
              ...(data.comentariosfeedback && {
                comentariosfeedback: data.comentariosfeedback,
              }),
              ...(data.retornocliente && {
                retornocliente: data.retornocliente,
              }),
            },
          );
          if (response && response.data) {
            setComerciais(prevState =>
              prevState.map(p =>
                p.id === selectedId.current
                  ? { ...p, melhoriadobreak: response.data }
                  : p,
              ),
            );
            toast.success('Informações salvas com sucesso');
          } else toast.error('Falha de comunicação com o sistema');

          hideModal();
        } catch (error) {
          if (error instanceof Yup.ValidationError) {
            const errors = getValidationErrors(error);
            formRef.current.setErrors(errors);
          }
          if (error instanceof Error) {
            toast.error(error.message);
          }
        }
        setLoadingSubmit(false);
      }
    },
    [hideModal],
  );

  const renderComunicacao = useCallback(
    melhoriadobreak => {
      // Para preencher o primeiro formulário aberto
      const initialData = {
        id: melhoriadobreak.id,
        emailnotificacao: melhoriadobreak.emailnotificacao,
        comentariosfeedback: melhoriadobreak.comentariosfeedback,
        retornocliente: melhoriadobreak.retornocliente,
        feedback: melhoriadobreak.feedback,
        notificacao: NotificacaoOptions.find(
          o => o.value === melhoriadobreak.notificacao,
        ),
        motivo: MotivoOptions.find(o => o.value === melhoriadobreak.motivo),
      };
      // Para preencher os próximos formulários abertos
      if (formRef.current) {
        formRef.current.setFieldValue(
          'emailnotificacao',
          melhoriadobreak.emailnotificacao,
        );
        formRef.current.setFieldValue(
          'comentariosfeedback',
          melhoriadobreak.comentariosfeedback,
        );
        formRef.current.setFieldValue(
          'retornocliente',
          melhoriadobreak.retornocliente,
        );
        formRef.current.setFieldValue('feedback', melhoriadobreak.feedback);
        formRef.current.setFieldValue(
          'notificacao',
          NotificacaoOptions.find(o => o.value === melhoriadobreak.notificacao),
        );
        formRef.current.setFieldValue(
          'motivo',
          MotivoOptions.find(o => o.value === melhoriadobreak.motivo),
        );
      }
      return (
        <PerfectScrollbar style={{ maxHeight: 'calc(100vh - 250px)' }}>
          <Form
            ref={formRef}
            onSubmit={handleSubmitComunicacao}
            initialData={initialData}
          >
            <Comunicacao>
              <div>
                <h5>Notificação</h5>
                <Select
                  type="default"
                  errorField=""
                  name="notificacao"
                  placeholder="Notificação"
                  options={NotificacaoOptions}
                  isSearchable
                  isClearable={false}
                  disabled={loadingSubmit}
                  fill={false}
                />
                <h5>Motivo</h5>
                <Select
                  type="default"
                  errorField=""
                  name="motivo"
                  placeholder="Motivo"
                  options={MotivoOptions}
                  isSearchable
                  isClearable={false}
                  disabled={loadingSubmit}
                  fill={false}
                />
                <h5>E-mail notificação</h5>
                <TextArea
                  placeholder="E-mail Notificação"
                  name="emailnotificacao"
                  height={150}
                  disable={false}
                  errorField=""
                  icon=""
                />
                <h5>Feedback</h5>
                <Switch name="feedback" />
              </div>
              <div>
                <h5>Comentários Feedback</h5>
                <TextArea
                  placeholder="Comentários Feedback"
                  name="comentariosfeedback"
                  height={150}
                  disable={false}
                  errorField=""
                  icon=""
                />
                <h5>Retorno Cliente</h5>
                <TextArea
                  placeholder="Retorno Cliente"
                  name="retornocliente"
                  height={150}
                  disable={false}
                  errorField=""
                  icon=""
                />
              </div>
            </Comunicacao>
            <div className="actions">
              <Button
                color="default"
                onClick={e => {
                  e.preventDefault();
                  hideModal();
                }}
              >
                CANCELAR
              </Button>
              <Button type="submit" color="primary">
                CONFIRMAR
              </Button>
            </div>
          </Form>
        </PerfectScrollbar>
      );
    },
    [
      MotivoOptions,
      NotificacaoOptions,
      handleSubmitComunicacao,
      hideModal,
      loadingSubmit,
    ],
  );

  const handleComunicacao = useCallback(
    c => {
      selectedId.current = c.id;
      if (formRef.current) formRef.current.setErrors({});
      showModal({
        title: 'COMUNICAÇÃO',
        component: renderComunicacao(c.melhoriadobreak),
        width: '50vw',
      });
    },
    [renderComunicacao, showModal],
  );

  const renderAvaliacaoHelp = useCallback(() => {
    return (
      <PerfectScrollbar style={{ height: 'calc(100vh - 250px)' }}>
        <AvaliacaoHelp>
          <tr>
            <th rowSpan={5}>Criatividade</th>
            <td rowSpan={5}>
              Conceito inovador, com grau de diferenciação em relação às outras
              obras audiovisuais.
            </td>
            <td>É inovador na técnica?</td>
          </tr>
          <tr>
            <td>É inovador no conceito cognitivo?</td>
          </tr>
          <tr>
            <td>É diferenciado da concorrência no conceito cognitivo?</td>
          </tr>
          <tr>
            <td>É diferenciado da concorrência na técnica?</td>
          </tr>
          <tr>
            <td>Gera alguma emoção (risos, lágrimas, reflexão, raiva etc)</td>
          </tr>
          <tr>
            <th rowSpan={5}>Linguagem</th>
            <td rowSpan={5}>
              Tom de comunicação atualizado e adequado ao público e serviço
              comunicado, com uma locução clara.
            </td>
            <td> A linguagem é clara?</td>
          </tr>
          <tr>
            <td>A linguagem é chamativa?</td>
          </tr>
          <tr>
            <td>A locução é compreensível?</td>
          </tr>
          <tr>
            <td>A locução é diferenciada?</td>
          </tr>
          <tr>
            <td>A linguagem é apropriada ao produto?</td>
          </tr>
          <tr>
            <th rowSpan={5}>Foco na Venda</th>
            <td rowSpan={5}>
              Direcionamento no que está sendo vendido ou comunicado.
            </td>
            <td> É focado na venda?</td>
          </tr>
          <tr>
            <td>Fala de valores?</td>
          </tr>
          <tr>
            <td>Direciona ao site/LOCAL?</td>
          </tr>
          <tr>
            <td>Proporciona engajamento?</td>
          </tr>
          <tr>
            <td>Apresenta os benefícios?</td>
          </tr>

          <tr>
            <th rowSpan={5}>Roteiro</th>
            <td rowSpan={5}>
              Cenas e diálogos bem estruturados, com sequências organizadas.
            </td>
            <td>Existe um argumento?</td>
          </tr>
          <tr>
            <td>A estrutura é apropriada?</td>
          </tr>
          <tr>
            <td>As cenas são bem pensadas?</td>
          </tr>
          <tr>
            <td>As sequências são lógicas?</td>
          </tr>
          <tr>
            <td>O texto é inteligente?</td>
          </tr>
          <tr>
            <th rowSpan={5}>Clareza na exposição</th>
            <td rowSpan={5}>
              Explicação clara dos benefícios do produto/serviço. Bons
              letterings.
            </td>
            <td> O produto está claro?</td>
          </tr>
          <tr>
            <td>Os letterings estão legíveis?</td>
          </tr>
          <tr>
            <td>Os benefícios estão claros?</td>
          </tr>
          <tr>
            <td>Existe um call to action? Uma chamada para ação?</td>
          </tr>
          <tr>
            <td>Os letterings estão diferenciados?</td>
          </tr>
          <tr>
            <th rowSpan={5}>Direção de arte</th>
            <td rowSpan={5}>
              Design detalhado e concepção visual cuidadosa, quanto a bons pack
              shots e efeitos gráficos em geral.
            </td>
            <td> O design é apropriado?</td>
          </tr>
          <tr>
            <td>A trilha sonora é agradável?</td>
          </tr>
          <tr>
            <td>Os efeitos gráficos são agradáveis visualmente?</td>
          </tr>
          <tr>
            <td>Há bons pack shots ou destaque do produto?</td>
          </tr>
          <tr>
            <td>O design é notável?</td>
          </tr>
          <tr>
            <th rowSpan={5}>Fotografia</th>
            <td rowSpan={5}>
              Estética apurada e qualidade na captura de imagens para o vídeo.
            </td>
            <td> Há estética na filmagem/ilustração?</td>
          </tr>
          <tr>
            <td>Há qualidade na captura de imagem/ilustração?</td>
          </tr>
          <tr>
            <td>Há boa resolução de imagem?</td>
          </tr>
          <tr>
            <td>A qualidade dos enquadramentos é perceptível?</td>
          </tr>
          <tr>
            <td>Percebemos uma boa escolha de cenas</td>
          </tr>
        </AvaliacaoHelp>
      </PerfectScrollbar>
    );
  }, []);

  const handleAvaliacaoHelp = useCallback(() => {
    showModal({
      title: 'AVALIAÇÃO',
      component: renderAvaliacaoHelp(),
    });
  }, [renderAvaliacaoHelp, showModal]);

  const handleAvaliacao = useCallback(
    (
      id: number,
      field:
        | 'criatividade'
        | 'clareza'
        | 'direcaodearte'
        | 'foconavenda'
        | 'fotografia'
        | 'linguagem'
        | 'roteiro',
      value: number,
    ) => {
      setDisableSave(false);
      setComerciais(prevState =>
        prevState.map(p =>
          p.id === id
            ? {
                ...p,
                melhoriadobreak: {
                  ...p.melhoriadobreak,
                  [field]: value * 2,
                  notageral: (
                    ((p.melhoriadobreak?.criatividade || 0) +
                      (p.melhoriadobreak?.clareza || 0) +
                      (p.melhoriadobreak?.direcaodearte || 0) +
                      (p.melhoriadobreak?.foconavenda || 0) +
                      (p.melhoriadobreak?.fotografia || 0) +
                      (p.melhoriadobreak?.linguagem || 0) +
                      (p.melhoriadobreak?.roteiro || 0) -
                      (p.melhoriadobreak?.[field] || 0) +
                      value * 2) /
                    7
                  )
                    .toFixed(2)
                    .replace('.', ','),
                },
              }
            : p,
        ),
      );
    },
    [],
  );

  const handleDadosClick = useCallback((c: Comercial) => {
    const dados = `CM: ${c.codmaterial}\r\nTÍTULO: ${c.titulo}\r\nCLIENTE: ${
      c.cliente.mnemonico
    }\r\nAGÊNCIA: ${c.agencia?.mnemonico || 'Indefinida'}\r\nPRODUTORA: ${c
      .produtora?.nome || 'Indefinida'}\r\nPONTO DE VENDA: ${
      c.ptovenda
    }\r\nEXIBIDORAS: ${
      new Set(c.enviaexibidor).size === 8
        ? 'REDE'
        : Array.from(new Set(c.enviaexibidor.map(e => e.emissora.sigla))).join()
    }\r\nDATA DE AVALIAÇÃO: ${
      c.melhoriadobreak?.updated_at
        ? format(new Date(c.melhoriadobreak.updated_at), 'dd/MM/yy')
        : 'Não avaliada'
    }\r\nINÍCIO DE EXIBIÇÃO: ${
      c.emailsent_at
        ? format(new Date(c.emailsent_at), 'dd/MM/yy')
        : 'Indefinida'
    }\r\nSUBCATEGORIA: ${c.melhoriadobreak?.melhoriadobreak_categoria
      ?.categoria || 'Indefinida'}`;
    if (!navigator.clipboard) {
      const dummy = document.createElement('textarea');
      // to avoid breaking orgain page when copying more words
      // cant copy when adding below this code
      // dummy.style.display = 'none'
      document.body.appendChild(dummy);
      // Be careful if you use texarea. setAttribute('value', value), which works with "input" does not work with "textarea". – Eduard
      dummy.value = dados;
      dummy.select();
      document.execCommand('copy');
      document.body.removeChild(dummy);
      toast.success('Dados copiados na a área de transferência');
    } else {
      navigator.clipboard
        .writeText(dados)
        .then(function() {
          toast.success('Dados copiados na a área de transferência');
        })
        .catch(function() {
          toast.success('Falha ao copiar dados para a área de transferência');
        });
    }
  }, []);

  /**
   * USE EFFECT
   */
  useEffect(() => {
    const controller = new AbortController();
    async function buscaCategorias() {
      try {
        const response = await api.get('/melhoriadobreak/categorias', {
          signal: controller.signal,
        });
        if (response && response.data) {
          setCategorias(
            response.data.map((d: MelhoriaDoBreak_Categoria) => ({
              value: d.id,
              label: d.categoria,
            })),
          );
        } else toast.error('Falha de comunicação com o sistema');
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else if (e instanceof AppError) toast.error(e.message);
        else {
          const appError = e as AppError;
          if (appError.message) toast.error(appError.message);
          else toast.error('Erro inesperado');
        }
      }
    }
    buscaCategorias();
    return () => {
      controller.abort();
    };
  }, []);

  useEffect(() => {
    const controller = new AbortController();
    async function buscaComerciais() {
      try {
        setLoading(true);
        const response = await api.get('/melhoriadobreak', {
          signal: controller.signal,
          params: {
            page: page,
            ...(filtro && { search: filtro }),
          },
        });
        if (response && response.data) {
          setComerciais(response.data.comerciais);
          setPages(response.data.pages);
        } else toast.error('Falha de comunicação com o sistema');
      } catch (e) {
        if (e instanceof Error) toast.error(e.message);
        else if (e instanceof AppError) toast.error(e.message);
        else {
          const appError = e as AppError;
          if (appError.message) toast.error(appError.message);
          else toast.error('Erro inesperado');
        }
      }
      setLoading(false);
    }
    buscaComerciais();
    return () => {
      controller.abort();
    };
  }, [page, filtro]);

  return (
    <Container $visible={displaySearch}>
      <Header>
        <div>
          <h4>MELHORIA DO BREAK</h4>
          <Button
            fill
            color="font"
            round
            onClick={() => setDisplaySearch(prevState => !prevState)}
          >
            <FiSearch />
          </Button>
        </div>
        <Pagination
          total={pages}
          activePage={page}
          onClick={page => setPage(page)}
        />
        <Button color="primary" onClick={handleSubmit} disabled={disableSave}>
          SALVAR
          <FiSave />
        </Button>
      </Header>

      <SearchBar $visible={displaySearch} id="filtro">
        <Form ref={ref} onSubmit={handleFiltroSubmit}>
          <Input
            name="filtro"
            placeholder="Busca"
            autoComplete="off"
            icon={<FiSearch />}
          />
        </Form>
      </SearchBar>

      <Tooltip target="filtro" position="bottom">
        Buscas possíveis:
        <br />
        Pelo título, CM, cliente, agência, produtura.
        <br />
        Pela data de aprovação usando os operadores &lt; e &gt;
        <br />
        Ex: &gt;01/01/2024 trará os comerciais aprovados a partir de 02/01/2024
      </Tooltip>
      <Card>
        <PerfectScrollbar className="scroll">
          {loading ? (
            <Loader />
          ) : filtro.length >= 3 && comerciais && comerciais.length === 0 ? (
            <div
              style={{
                width: '100%',
                position: 'absolute',
              }}
            >
              <NotFound img={NoSearch} title="Nenhum comercial">
                encontrado por{' '}
                <b>
                  <u>{filtro}</u>
                </b>
              </NotFound>
            </div>
          ) : (
            <Table>
              <THead>
                <tr>
                  <th>PREVIEW</th>
                  <th>DADOS</th>
                  <th>
                    AVALIAÇÕES
                    <Button
                      fill
                      color="font"
                      round
                      onClick={handleAvaliacaoHelp}
                    >
                      <FiHelpCircle />
                    </Button>
                  </th>
                  <th>NOTA</th>
                  <th>NOTIFIC.</th>
                  <th>COMUNIC.</th>
                </tr>
              </THead>
              <tbody>
                {comerciais &&
                  comerciais.length > 0 &&
                  comerciais.map((c, index) => (
                    <tr key={c.id}>
                      <td>
                        <Thumbnail>
                          <ThumbnailContainer
                            onAuxClick={() =>
                              c.midia?.preview_url &&
                              window.open(c.midia?.preview_url, '_blank')
                            }
                            onClick={() =>
                              handlePlayer(c.midia?.preview_url || '')
                            }
                          >
                            <Img
                              key={`img${c.id}`}
                              onClick={() =>
                                handlePlayer(c.midia?.preview_url || '')
                              }
                              src={c.midia?.thumbnail_url || ''}
                              loader={<Spinner />}
                              unloader={<img src={notfound} alt="sem thumb" />}
                            />

                            <FiPlay className="icon_play" />
                          </ThumbnailContainer>
                        </Thumbnail>
                      </td>
                      <td>
                        <Dados onClick={() => handleDadosClick(c)}>
                          <div className="text">
                            <p id={`cm_${index}`}>CM: {c.codmaterial}</p>
                            <Tooltip position="left" target={`cm_${index}`}>
                              CM: {c.codmaterial}
                            </Tooltip>
                            <p id={`titulo_${index}`}>TÍTULO: {c.titulo}</p>
                            <Tooltip position="left" target={`titulo_${index}`}>
                              TÍTULO: {c.titulo}
                            </Tooltip>
                            <p id={`cliente_${index}`}>
                              CLIENTE: {c.cliente.mnemonico}
                            </p>
                            <Tooltip
                              position="left"
                              target={`cliente_${index}`}
                            >
                              CLIENTE: {c.cliente.mnemonico}
                            </Tooltip>
                            <p id={`agencia_${index}`}>
                              AGÊNCIA: {c.agencia?.mnemonico}
                            </p>
                            <Tooltip
                              position="left"
                              target={`agencia_${index}`}
                            >
                              AGÊNCIA: {c.agencia?.mnemonico}
                            </Tooltip>
                            <p id={`produtora_${index}`}>
                              PRODUTORA: {c.produtora?.nome}
                            </p>
                            <Tooltip
                              position="left"
                              target={`produtora_${index}`}
                            >
                              PRODUTORA: {c.produtora?.nome}
                            </Tooltip>
                          </div>
                          <div>
                            <div>
                              <p id={`ptovenda_${index}`}>
                                PONTO DE VENDA: {c.ptovenda}
                              </p>
                              <Tooltip
                                position="right"
                                target={`ptovenda_${index}`}
                              >
                                PONTO DE VENDA: {c.ptovenda}
                              </Tooltip>
                              <p id={`exibidoras_${index}`}>
                                EXIBIDORAS:{' '}
                                {new Set(c.enviaexibidor).size === 8
                                  ? 'REDE'
                                  : Array.from(
                                      new Set(
                                        c.enviaexibidor.map(
                                          e => e.emissora.sigla,
                                        ),
                                      ),
                                    ).join()}
                              </p>
                              <Tooltip
                                position="right"
                                target={`exibidoras_${index}`}
                              >
                                EXIBIDORAS:{' '}
                                {new Set(c.enviaexibidor).size === 8
                                  ? 'REDE'
                                  : Array.from(
                                      new Set(
                                        c.enviaexibidor.map(
                                          e => e.emissora.sigla,
                                        ),
                                      ),
                                    ).join()}
                              </Tooltip>
                              <p id={`data_${index}`}>
                                DATA DE AVALIAÇÃO:{' '}
                                {c.melhoriadobreak?.updated_at
                                  ? format(
                                      new Date(c.melhoriadobreak.updated_at),
                                      'dd/MM/yy',
                                    )
                                  : 'Não avaliada'}
                              </p>
                              <Tooltip
                                position="right"
                                target={`data_${index}`}
                              >
                                DATA DE AVALIAÇÃO:{' '}
                                {c.melhoriadobreak?.updated_at
                                  ? format(
                                      new Date(c.melhoriadobreak.updated_at),
                                      'dd/MM/yy',
                                    )
                                  : 'Não avaliada'}
                              </Tooltip>
                              <p id={`dataaprov_${index}`}>
                                DATA DE APROVAÇÃO:{' '}
                                {c.midia?.checked_at
                                  ? format(
                                      new Date(c.midia.checked_at),
                                      'dd/MM/yy',
                                    )
                                  : 'Indefinida'}
                              </p>
                              <Tooltip
                                position="right"
                                target={`dataaprov_${index}`}
                              >
                                DATA DE APROVAÇÃO:{' '}
                                {c.midia?.checked_at
                                  ? format(
                                      new Date(c.midia.checked_at),
                                      'dd/MM/yy',
                                    )
                                  : 'Indefinida'}
                              </Tooltip>
                              {c.melhoriadobreak?.melhoriadobreak_categoria
                                ?.categoria && (
                                <div className="subcategoria">
                                  <p id={`subcategoria_${index}`}>
                                    SUBCATEGORIA:{' '}
                                    {
                                      c.melhoriadobreak
                                        .melhoriadobreak_categoria.categoria
                                    }
                                  </p>
                                  <Tooltip
                                    position="right"
                                    target={`subcategoria_${index}`}
                                  >
                                    SUBCATEGORIA:{' '}
                                    {
                                      c.melhoriadobreak
                                        .melhoriadobreak_categoria.categoria
                                    }
                                  </Tooltip>
                                  <Button
                                    fill
                                    color="font"
                                    round
                                    size="xsm"
                                    onClick={e => {
                                      e.stopPropagation();
                                      handleEditCategoria(c);
                                    }}
                                  >
                                    <FiEdit2 />
                                  </Button>
                                </div>
                              )}
                            </div>
                          </div>
                        </Dados>
                        {!c.melhoriadobreak?.melhoriadobreak_categoria
                          ?.categoria && (
                          <div
                            style={{ paddingTop: '0.1rem', maxWidth: '380px' }}
                          >
                            <SelectWithoutForm
                              type="default"
                              errorField=""
                              name="categoria"
                              placeholder="Categoria"
                              options={categorias}
                              isSearchable
                              isClearable={false}
                              disabled={loadingSubmit}
                              fill={false}
                              onChange={(categoria: ISelectOption) => {
                                selectedId.current = c.id;
                                handleSubmitCategoria(c.id, categoria.value);
                              }}
                            />
                          </div>
                        )}
                      </td>
                      <td>
                        <Avaliacoes>
                          <div>
                            <div>
                              <p>CRIATIVIDADE:</p>{' '}
                              <ReactStars
                                size={24}
                                value={
                                  (c.melhoriadobreak?.criatividade ?? 0) / 2
                                }
                                onChange={value =>
                                  handleAvaliacao(c.id, 'criatividade', value)
                                }
                              />
                            </div>
                            <div>
                              <p>FOCO NA VENDA:</p>{' '}
                              <ReactStars
                                size={24}
                                value={
                                  (c.melhoriadobreak?.foconavenda ?? 0) / 2
                                }
                                onChange={value =>
                                  handleAvaliacao(c.id, 'foconavenda', value)
                                }
                              />
                            </div>
                            <div>
                              <p>LINGUAGEM:</p>{' '}
                              <ReactStars
                                size={24}
                                value={(c.melhoriadobreak?.linguagem ?? 0) / 2}
                                onChange={value =>
                                  handleAvaliacao(c.id, 'linguagem', value)
                                }
                              />
                            </div>
                            <div>
                              <p>DIREÇÃO DE ARTE:</p>{' '}
                              <ReactStars
                                size={24}
                                value={
                                  (c.melhoriadobreak?.direcaodearte ?? 0) / 2
                                }
                                onChange={value =>
                                  handleAvaliacao(c.id, 'direcaodearte', value)
                                }
                              />
                            </div>
                          </div>
                          <div>
                            <div>
                              <p>CLAREZA:</p>{' '}
                              <ReactStars
                                size={24}
                                value={(c.melhoriadobreak?.clareza ?? 0) / 2}
                                onChange={value =>
                                  handleAvaliacao(c.id, 'clareza', value)
                                }
                              />
                            </div>
                            <div>
                              <p>ROTEIRO:</p>{' '}
                              <ReactStars
                                size={24}
                                value={(c.melhoriadobreak?.roteiro ?? 0) / 2}
                                onChange={value =>
                                  handleAvaliacao(c.id, 'roteiro', value)
                                }
                              />
                            </div>
                            <div>
                              <p>FOTOGRAFIA:</p>{' '}
                              <ReactStars
                                size={24}
                                value={(c.melhoriadobreak?.fotografia ?? 0) / 2}
                                onChange={value =>
                                  handleAvaliacao(c.id, 'fotografia', value)
                                }
                              />
                            </div>
                          </div>
                        </Avaliacoes>
                      </td>
                      <td style={{ textAlign: 'center' }}>
                        <h3>{c.melhoriadobreak?.notageral || '-'}</h3>
                      </td>
                      <td>
                        {c.melhoriadobreak?.notificacao && (
                          <Flag
                            name={c.melhoriadobreak.notificacao}
                            type={c.melhoriadobreak.notificacao}
                          />
                        )}
                      </td>
                      <td>
                        <Botoes>
                          <Button
                            id={`button_comunicacao${c.id}`}
                            fill
                            color="font"
                            round
                            onClick={() => handleComunicacao(c)}
                            disabled={
                              !disableSave ||
                              !c.melhoriadobreak ||
                              (!c.melhoriadobreak.clareza &&
                                !c.melhoriadobreak.criatividade &&
                                !c.melhoriadobreak.direcaodearte &&
                                !c.melhoriadobreak.foconavenda &&
                                !c.melhoriadobreak.fotografia &&
                                !c.melhoriadobreak.linguagem &&
                                !c.melhoriadobreak.roteiro)
                            }
                          >
                            <FiMessageCircle />
                          </Button>
                          {(!disableSave ||
                            !c.melhoriadobreak ||
                            (!c.melhoriadobreak.clareza &&
                              !c.melhoriadobreak.criatividade &&
                              !c.melhoriadobreak.direcaodearte &&
                              !c.melhoriadobreak.foconavenda &&
                              !c.melhoriadobreak.fotografia &&
                              !c.melhoriadobreak.linguagem &&
                              !c.melhoriadobreak.roteiro)) && (
                            <Tooltip
                              position="left"
                              target={`button_comunicacao${c.id}`}
                            >
                              AVALIE OU SALVE AS AVALIAÇÕES
                            </Tooltip>
                          )}
                        </Botoes>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </Table>
          )}
        </PerfectScrollbar>
      </Card>
      <PlayerBaixa
        open={player.open}
        toggleModal={() => closeVideo()}
        pipe={player.pipe}
        url={player.midia_url}
      />
    </Container>
  );
}
